import {SmartComponent} from "smart-component-js";

/**
 * CTA campus dell'hero delle landing evento: il click attiva il campus, mostra il blocco con il suo evento e
 * preseleziona la school del form. Anche la scelta della school nel form aggiorna la CTA attiva.
 */
class EventCampusComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        params.className = "EventCampusComponent";
        super(element, parentComponent, params);

        this.$el = $(element);
        this.$triggers = this.$el.find('.event-campus__trigger');
        this.$infos = this.$el.find('.event-campus__info');

        this.init();
    }

    init() {
        this.$triggers.click((e) => {
            let code = $(e.currentTarget).data('code');
            this.activate(code);
            this.selectSchool(code);
        });

        $(document).on('change', '.landing-form #school', (e) => {
            this.activate($(e.currentTarget).val());
        });
    }

    activate(code) {
        this.$triggers.removeClass('active');
        this.$infos.hide();

        if (!code) {
            return;
        }

        this.$triggers.filter((i, el) => $(el).data('code') == code).addClass('active');
        this.$infos.filter((i, el) => $(el).data('code') == code).show();
    }

    selectSchool(code) {
        let $school = $('.landing-form #school');

        if ($school.length === 0 || $school.val() == code || $school.find('option').filter((i, el) => el.value == code).length === 0) {
            return;
        }

        $school.val(code).trigger('change');
    }
}

export default EventCampusComponent;
